/* eslint-disable camelcase */
import React, { useEffect, useMemo, useState } from 'react';
import { get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';

// eslint-disable-next-line react/prop-types
function AiSessionPlan({ data, type }) {
  const isFirstSession = useMemo(() => type === 'first', [type]);

  const [hasData, setHasData] = useState(false);

  const [firstSessionPlan, setFirstSessionPlan] = useState(() => {
    const plan = {
      session_summary_for_student: '',
      health_considerations: [''],
      session_plan_breakdown: {
        warm_up: [
          {
            asana: '',
            minutes: 0,
            cues: ''
          }
        ],
        exercise: [
          {
            asana: '',
            minutes: 0,
            cues: ''
          }
        ],
        cool_down: [
          {
            asana: '',
            minutes: 0,
            cues: ''
          }
        ]
      }
    };

    return plan;
  });

  const loadFirstSessionPlan = async (studentUUID) => {
    const url = get_api_url(
      `/v2/crons-tasks/poc/first_session_plan?student_uuid=${studentUUID}`,
      false,
      true
    );

    // console.log("endpoint", url);
    try {
      const response = await get_api(url, true);
      setFirstSessionPlan(response.data.plan);
      setHasData(true);
    } catch (e) {
      console.log('api call failed', e);
    }
  };

  useEffect(() => {
    const { student_uuid } = data;
    if (isFirstSession) {
      loadFirstSessionPlan(student_uuid);
    }
  }, [data, isFirstSession]);

  const displayFirstSessionPlan = () => (
    <div className="flex flex-col w-full">
      <p className="text-lg font-semibold">Summary for student</p>
      <p className="text-sm">{firstSessionPlan.session_summary_for_student}</p>

      <p className="text-lg font-semibold">Health Consideration</p>
      <ul className="list-inside list-disc">
        {firstSessionPlan.health_considerations.map((val) => (
          <li>{val}</li>
        ))}
      </ul>
      <p className="text-lg font-semibold">Session Plan Breakdown</p>
      <p className="text-sm font-semibold">Warm up</p>
      <ul className="list-inside list-disc">
        {firstSessionPlan.session_plan_breakdown.warm_up.map((val) => (
          <li>
            <span className="font-medium">{val.asana}</span> ({val.minutes} Min): {val.cues}
          </li>
        ))}
      </ul>
      <p className="text-sm font-semibold">Excercise/Build-Up/Peak-Pose</p>
      <ul className="list-inside list-disc">
        {firstSessionPlan.session_plan_breakdown.exercise.map((val) => (
          <li>
            <span className="font-medium">{val.asana}</span> ({val.minutes} Min): {val.cues}
          </li>
        ))}
      </ul>
      <p className="text-sm font-semibold">Cool Down</p>
      <ul className="list-inside list-disc">
        {firstSessionPlan.session_plan_breakdown.cool_down.map((val) => (
          <li>
            <span className="font-medium">{val.asana}</span> ({val.minutes} Min): {val.cues}
          </li>
        ))}
      </ul>
    </div>
  );

  // eslint-disable-next-line react/no-array-index-key
  return (
    <div className="">
      <div className="mb-10 ">
        <div className="font-bold text-[24px] capitalize">AI Session plan: {type}</div>
        {!hasData && <p>Loading...</p>}
        {hasData && isFirstSession && displayFirstSessionPlan()}
      </div>
    </div>
  );
}

export default AiSessionPlan;
